import { RefsVertical } from "./RefsVertical.js";
import "react";
import { Modal } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
//#region src/modules/shared/RefsByTypeTitles/components/RefsModal.tsx
function RefsModal({ closeHandler, refsByType }) {
	return /* @__PURE__ */ jsx(Modal, {
		header: "Refs",
		closeHandler,
		escPressClose: true,
		children: /* @__PURE__ */ jsx("div", {
			className: "mt-base",
			children: /* @__PURE__ */ jsx(RefsVertical, { refsByType })
		})
	});
}
//#endregion
export { RefsModal };

//# sourceMappingURL=RefsModal.js.map